class PimV2Pricing {

    constructor() {
        this.elements = {
            buttonTotal:
                document.getElementById(
                    'btn-total'
                ),

            buttonCurrentPrice:
                document.querySelector(
                    '#btn-total .pim-v2-current-price'
                ),

            buttonComparePrice:
                document.querySelector(
                    '#btn-total .pim-v2-compare-price'
                ),

            stickyTotal: document.getElementById(
                'sticky-bar-total'
            ),

            stickyTotalMobile: document.getElementById(
                'sticky-bar-total-mobile'
            )
        };

        this.bindEvents();
    }

    bindEvents() {

        document.addEventListener(
            'pim-v2:subscription-change',
            (event) => {

                this.updatePrices(
                    event.detail.pricing
                );

            }
        );
    }

    formatPrice(price) {
        return `$${Number(price).toFixed(2)}`;
    }

    updatePrices(pricing) {

        if (!pricing) {
            return;
        }

        const currentPrice =
            this.formatPrice(
                pricing.currentPrice
            );

        const comparePrice =
            this.formatPrice(
                pricing.comparePrice
            );

        if (this.elements.buttonCurrentPrice) {
            this.elements.buttonCurrentPrice.textContent =
                currentPrice;
        }

        if (this.elements.buttonComparePrice) {

            const showComparePrice =
                pricing.currentPrice <
                pricing.comparePrice;

            this.elements.buttonComparePrice.textContent =
                comparePrice;

            this.elements.buttonComparePrice.style.display =
                showComparePrice
                    ? 'inline'
                    : 'none';
        }

        [
            this.elements.stickyTotal,
            this.elements.stickyTotalMobile
        ].forEach((element) => {

            if (!element) {
                return;
            }

            const currentPriceElement =
                element.querySelector(
                    '.pim-v2-current-price'
                );

            const comparePriceElement =
                element.querySelector(
                    '.pim-v2-compare-price'
                );

            if (currentPriceElement) {
                currentPriceElement.textContent =
                    currentPrice;
            }

            if (comparePriceElement) {

                const showComparePrice =
                    pricing.currentPrice <
                    pricing.comparePrice;

                comparePriceElement.textContent =
                    comparePrice;

                comparePriceElement.style.display =
                    showComparePrice
                        ? 'inline'
                        : 'none';
            }
        });
    }
}

document.addEventListener(
    'DOMContentLoaded',
    () => {
        new PimV2Pricing();
    }
);